import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'lg-scroll-top',
  styleUrl: 'lg-scroll-top.scss',
})
export class LgScrollTop {
  private offset = 50;
  private scrollTop?: any;

  componentDidLoad() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > this.offset) {
        this.scrollTop.classList.add('show');
      } else {
        this.scrollTop.classList.remove('show');
      }
    });
  }

  goToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  render() {
    return (
      <Host>
        <button class="scroll-top" type="button" ref={el => (this.scrollTop = el)} onClick={this.goToTop}></button>
      </Host>
    );
  }
}
